import { useEffect, useMemo, useState } from "react";
import { useUniModalPortableContainer } from "../hooks/useUniModalPortableContainer";
import { useColumnVisibility } from "../hooks/useColumnVisibility";
// import JSDisplayObject from "./JSDisplayObject";
import { js_utils } from "../utils/frfr-js-utils";
import Btn from "./Btn";
import JSDisplayValue from "./JSDisplayValue";
import UniModalPresentationalBottomSheetKoglovo from "./UniModalPresentationalBottomSheetKoglovo";
import TableGenerator from "./TableGenerator";
import UniLimiter from "./UniLimiter";
import UniModalPortableContainer from "./UniModalPortableContainer";
import UniPaper from "./UniPaper";
import UniSpinnerClassic from "./UniSpinnerClassic";
import UniBtn from "./UniBtn";
import RapidoziDisplayValue from "./RapidoziDisplayValue";
import UniViewMultimodeTableGenerator from "./UniViewMultimodeTableGenerator";
import AdminTableToolbar from "./AdminTableToolbar";


const ViewGeneratorSimpleV4 = (props) => {
  const {
    route_freshness,
    rapidoziViewDefinition,
    viewDefinition,
    viewArr,
    fetching,
    jsxSpinner, // TODO
    // Optional: JSX filter controls rendered inside the toolbar
    jsxToolbarFilters,
    // Optional: JSX rendered next to the search field in row 1
    jsxToolbarSearchRowExtra,
  } = props;
  const {
    cbSubmitEntityCreate,
  } = rapidoziViewDefinition;
  const {
    cbEntityKeyExtractor,
    cbEntityColumnValExtractor,
    cbRefresh,
    cbEntityActionsJsx,
    options,

    //TODO NOVO
    cbEntityColumnValFixForDisplay,
    cbEntityColumnTitleTranslator,

    cbModalCreate,
    cbModalCreateAlt,
    cbSubmitCreate,
    cbSubmitUpdate,
  } = viewDefinition;

  // ── Global search state ──
  const [searchTerm, setSearchTerm] = useState('');

  let jsxSpinnerCustom = null;
  jsxSpinnerCustom = (
    <UniSpinnerClassic />
  );
  if (jsxSpinner) {
    jsxSpinnerCustom = jsxSpinner;
  }

  let table_additional_column_keys = [];
  if (Array.isArray(viewDefinition.table_additional_column_keys)) {
    table_additional_column_keys = viewDefinition.table_additional_column_keys;
  }

  let is_show_entity = true;
  if (options?.entity_col_disabled === true) {
    is_show_entity = false;
  }
  let showSelectable = false;
  if (options?.showSelectable === true) {
    showSelectable = true;
  }

  // ── Derive toggleable column list for the column-visibility hook ──
  const toggleableColumns = useMemo(() => {
    const cols = [];
    const seenKeys = new Set();
    const pushCol = (keyRaw, titleRaw) => {
      const key = typeof keyRaw === 'string' ? keyRaw.trim() : '';
      if (!key || seenKeys.has(key)) {
        return;
      }
      seenKeys.add(key);
      cols.push({ key, title: (typeof titleRaw === 'string' && titleRaw.trim() !== '') ? titleRaw : key });
    };
    if (is_show_entity) {
      pushCol('KEY', 'KEY');
      pushCol('ENTITY', 'ENTITY');
    }
    table_additional_column_keys.forEach((item) => {
      if (typeof item === 'string') {
        const k = item.trim();
        pushCol(k, k);
      } else if (item && typeof item === 'object' && item.key) {
        pushCol(item.key, item.title);
      }
    });
    return cols;
  }, [is_show_entity, table_additional_column_keys]);

  // ── Column visibility (persisted to localStorage) ──
  const tableKey = viewDefinition.view_key || 'admin_table';
  const {
    columnsWithVisibility,
    toggleColumn,
    isColumnVisible,
    setAllColumnsVisible,
    resetColumnVisibility,
  } = useColumnVisibility(
    tableKey,
    toggleableColumns
  );

  // -----
  const {
    setUniModalPortableContent,
    setUniModalPortableClose,
    uniModalPortableContainerPack,
  } = useUniModalPortableContainer();
  // -----

  useEffect(() => { // REFRESH BY ROUTE (or refresh once on mount)
    cbRefresh();
  }, [route_freshness]);

  console.log('viewArr', viewArr);

  let arr = [];
  let jsxError = null;
  if (fetching === true) {
    // spinner handled by UniViewMultimodeTableGenerator
  } else {
    if (Array.isArray(viewArr)) {
      console.log('viewArr', viewArr);
      arr = viewArr;
    } else {
      // ERROR
      jsxError = (
        <div className="jsunicompo-display-velue-error-msg"><span>ERROR: viewArr is not an Array!</span></div>
      );
    }
  }

  // ── Global search filtering ──
  const arrSearchFiltered = useMemo(() => {
    if (!searchTerm.trim()) return arr;
    const lower = searchTerm.toLowerCase();
    return arr.filter(item => {
      if (!item || typeof item !== 'object') return false;
      return Object.values(item).some(val => {
        if (val === null || val === undefined) return false;
        return String(val).toLowerCase().includes(lower);
      });
    });
  }, [arr, searchTerm]);

  //
  let _tableBlueprint_columns_entity = [];
  if (is_show_entity && isColumnVisible('KEY')) {
    _tableBlueprint_columns_entity.push({
      key: 'KEY',
      title: 'KEY',
      sortable: true,
      filterable: true,
      searchable: false,
      extraClassTh: 'uu-text-nowrap',
      tdCb: (row, k, col_index, row_index) => {
        const entity = row;
        let id = null;
        if (typeof cbEntityKeyExtractor === 'function') {
          id = cbEntityKeyExtractor(entity);
        }
        return (<JSDisplayValue val={id} />);
      },
      cellValueExtractor: (row, col_key, col_index, row_index) => {
        const entity = row;
        let id = null;
        if (typeof cbEntityKeyExtractor === 'function') {
          id = cbEntityKeyExtractor(entity);
        }
        return id;
      },
      resizable: true,
      resizableMinWidth: 12,
      minWidth: 64,
    });
  }
  if (is_show_entity && isColumnVisible('ENTITY')) {
    _tableBlueprint_columns_entity.push({
      key: 'ENTITY',
      title: 'ENTITY',
      sortable: false,
      filterable: false,
      searchable: false,
      extraClassTh: 'uu-text-nowrap',
      tdCb: (row, row_index, col_index) => { return (<JSDisplayValue val={row} initialCollapsed={true} />); },
      resizable: true,
      minWidth: 144,
    });
  }

  let _tableBlueprint_columns_4 = [];
  if (typeof cbEntityColumnValExtractor === 'function') {
    _tableBlueprint_columns_4 = table_additional_column_keys
      .filter((item) => {
        const k = typeof item === 'string' ? item.trim() : (item?.key || '').trim();
        return isColumnVisible(k);
      })
      .map((column_key) => {
        const col_blu = {
          key: column_key,
          title: column_key,
          sortable: true,
          filterable: true,
          searchable: false,
          tdCb: (row, k, col_index, row_index) => {
            const val = cbEntityColumnValExtractor(row, k);
            if (typeof cbEntityColumnValFixForDisplay === 'function') {
              const val_to_display = cbEntityColumnValFixForDisplay(k, val);
              return (<JSDisplayValue val={val_to_display} />);
            }
            return (<JSDisplayValue val={val} />);
          },
          resizable: true,
          resizableMinWidth: 12,
          minWidth: 128,
        };
        if (typeof cbEntityColumnTitleTranslator === 'function') {
          col_blu.title = cbEntityColumnTitleTranslator(column_key);
        }
        return col_blu;
      });
  } else {
    _tableBlueprint_columns_4 = table_additional_column_keys
      .filter((item) => {
        const k = typeof item === 'string' ? item.trim() : (item?.key || '').trim();
        return isColumnVisible(k);
      })
      .map((item) => {
        if (typeof item === 'string') {
          return {
            key: item,
            title: item,
            resizable: true,
            resizableMinWidth: 12,
            minWidth: 128,
          };
        } else {
          return {
            minWidth: 128,
            resizable: true,
            resizableMinWidth: 12,
            ...item,
          };
        }
      });
  }

  //
  const tableBlueprint_columns = [
    {
      key: 'No',
      title: '#',
      sortable: false,
      filterable: false,
      searchable: false,
      tdCb: (row, k, col_index, row_index) => { return (row_index + 1); },
      resizable: true,
      resizableMinWidth: 12,
      minWidth: 32,
    },
    {
      key: 'Actions',
      title: 'Actions',
      sortable: false,
      filterable: false,
      searchable: false,
      extraClass: 'adm-row-actions',
      extraClassTh: 'uu-text-wrap',
      tdCb: (row, k, col_index, row_index) => {
        const entity = row;
        return typeof cbEntityActionsJsx === 'function' ? (cbEntityActionsJsx(entity)) : (null);
      },
      resizable: true,
      resizableMinWidth: 12,
      minWidth: 160,
    },
    ..._tableBlueprint_columns_entity,
    ..._tableBlueprint_columns_4,
  ];

  // convert data to shallow (keyval pairs) Array of Objects for sorting and filtering table
  console.log('arr', arr);
  let arrFixed = arrSearchFiltered;
  if (typeof cbEntityColumnValExtractor === 'function') {
    arrFixed = arrSearchFiltered.map((entity, row_index) => {
      const fixed_entity = {
        ...entity,
      };
      table_additional_column_keys.forEach((key) => {
        const val = cbEntityColumnValExtractor(entity, key);
        fixed_entity[key] = val;
      });
      return fixed_entity;
    });
  }
  console.log('arrFixed', arrFixed);

  // jsxToolbarFilters can come from props or from viewDefinition
  const _jsxToolbarFilters = jsxToolbarFilters || viewDefinition.jsxToolbarFilters || null;

  return (
    <>
      <div className="view-generator-simple adm-table-v2">
        <UniLimiter maximize fullWidth>

          {jsxError}

          {/* ── Toolbar ─────────────────────────────────────────── */}
          <AdminTableToolbar
            searchValue={searchTerm}
            onSearchChange={setSearchTerm}
            jsxFilters={_jsxToolbarFilters}
            jsxSearchRowExtra={jsxToolbarSearchRowExtra}
            columns={columnsWithVisibility}
            onToggleColumn={toggleColumn}
            onShowAllColumns={() => setAllColumnsVisible(true)}
            onHideAllColumns={() => setAllColumnsVisible(false)}
            onResetColumns={resetColumnVisibility}
            onCreateClick={() => { cbModalCreate(cbSubmitCreate); }}
            onCreateAltClick={typeof cbModalCreateAlt === 'function' ? () => { cbModalCreateAlt(cbSubmitCreate); } : undefined}
            onRefreshClick={() => { cbRefresh?.(); }}
          />

          {/* ── Table ───────────────────────────────────────────── */}
          <UniViewMultimodeTableGenerator
            columnWidthStorageKey={tableKey}
            viewMultimodeBlueprint={{
              freshness: null,
              general: {
                pagination_enabled: true,
                pagination_rowsPerPageInitial: 10,
                responsiveTable: true,
                widgetExtraClass: "frfr-table-generator__pack--pagination-left",
              },
              table: {
                showFilterRow: true,
                showSelectable: showSelectable,
                showSelectableSingular: false,
                resizable: true,
                resizableColumnMinWidth: 12,
                extraClass: 'frfr-table__table uu-text-nowrap frfr-table__table--alien-mui-basic-table frfr-table__table--adm-v2',
              },
              defaultColumnBlueprint: {
                sortable: true,
                filterable: true,
                searchable: false,
                tdCb: (row, col_key, col_index, row_index) => { return (<RapidoziDisplayValue val={row?.[col_key]} />); },
              },
              columns: tableBlueprint_columns,
              row: {
                rowKeyExtractor: cbEntityKeyExtractor,
              },
            }}
            fetching={fetching}
            rowsData={arrFixed}
            jsxSpinnerCustom={jsxSpinnerCustom}
            widgetExtraClass={'frfr-table-generator__pack--alien-mui-basic-table-widget'}
            tableExtraClass={''}
            cbOnSelectionChange={props.cbOnSelectionChange}
          />

        </UniLimiter>

        <UniModalPortableContainer
          uniModalPortableContainerPack={uniModalPortableContainerPack}
          ComponentModal={UniModalPresentationalBottomSheetKoglovo}
          containerOptions={null}
        />
      </div>
    </>
  );
};

export default ViewGeneratorSimpleV4;